import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import Calendar from "./../layout/Calendar";
import FilterElement from "./../layout/FilterElement";

import { signOut } from "../../store/actions/authAction";
import { updateFilterElement } from "../../store/actions/filterElementAction";

import Footer from "../Footer/Footer";
import ToggleButtonGroupBkash from "../Shared/ToggleButtonGroupBkash";
import "./../layout/styles/filter.css";
import GeneralReports from "./GeneralReports";
import MerchantReports from "./MerchantReports";
import "./style.css";
import AcquisitionReports from "./AcquisitionReports";
import CategorizationReports from "./category/Categorization/categorizationReports";

const online_scope_reports = [
  {
    name: "Lead status report",
    url: `/api/online/v1/generate-lead-report`,
    filename: "online_lead",
    file_type: "csv",
  },
  {
    name: "Online call report",
    url: `/api/online/v1/generate-call-report`,
    filename: "online_call",
    file_type: "xlsx",
  },
  {
    name: "Online MAO performance report",
    url: `/api/online/v1/generate-mao-performance-report`,
    filename: "online_mao_performance",
    file_type: "xlsx",
  },
  {
    name: "Email history report",
    url: `/api/online/v1/email-history-report`,
    filename: "email_history",
    file_type: "xlsx",
  },
];

const outlet_calls_by_merchandisersList = [
  {
    name: "Raw Data Report",
    url: `/api/reports/v1/raw-data-report`,
    filename: "raw_data",
    file_type: "xlsx",
  },
  {
    name: "Lat Long Report Merchandiser",
    url: `/api/reports/v3/get-lat-lng-report-merchant`,
    filename: "lat_lng_merchant",
    file_type: "xlsx",
    userTypes: ["bkash-super-user", "area_manager", "territory_manager"],
  },
  {
    name: "MDO Performance Report",
    url: `/api/reports/v1/mdo-wise-report`,
    filename: "mdo_data",
    file_type: "xlsx",
  },

  {
    name: "Assisted eKYC Report",
    url: `/api/ekyc/v1/assisted-ekyc-report`,
    filename: "assisted_ekyc_data",
    file_type: "xlsx",
  },
  // {
  //   name: "Merchant raw KYC Report",
  //   url: `/api/reports/v3/get-raw-merchant-kyc-data`,
  //   filename: "raw_merchant_kyc",
  //   file_type: "zip",
  //   userTypes: ["bkash-super-user"],
  // },
  {
    name: "Merchant Raw Transaction report ",
    url: `/api/reports/v3/get-raw-merchant-trn-data`,
    filename: "raw_merchant_transaction",
    file_type: "zip",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Lat Long Report",
    url: `/api/reports/v3/get-lat-lng-report`,
    filename: "lat_lng_report",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },

  {
    name: "MMO Call Summery Report",
    url: `/api/reports/v3/mmo-call-summery-report`,
    filename: "mmmo_call_summary",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },

  {
    name: "Territory Summary Report",
    url: `/api/reports/v3/territory-summery-report`,
    filename: "territory_summary_report",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "MMO Visit Summary Report",
    url: `/api/reports/v3/mmo-visit-summery-report`,
    filename: "MMO_visit_summary_report",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Merchant Call Report",
    url: `/api/reports/v2/merchant-call-report`,
    filename: "merchant_call",
    file_type: "xlsx",
  },
  {
    name: "Assigned Route Report",
    url: `/api/reports/v3/assigned-route-report`,
    filename: "assigned_route",
    file_type: "xlsx",
  },
  {
    name: "Route Call Report",
    url: `/api/reports/v3/route-call-report`,
    filename: "route_call_report",
    file_type: "xlsx",
  },
  {
    name: "MDO Covid Phase Performance Report",
    url: `/api/reports/v2/mdo-wise-covid-report`,
    filename: "mdo_covid_phase_data",
    file_type: "xlsx",
  },
  {
    name: "KYC Action Report",
    url: `/api/reports/v2/kyc-action-report`,
    filename: "kyc_action_report",
    file_type: "xlsx",
  },
  {
    name: "Attendance Report",
    url: `/api/reports/v3/attendance-report`,
    filename: "attendence_report",
    file_type: "xlsx",
  },
  {
    name: "Daily MMO Performance Report",
    url: `/api/reports/v3/daily-mmo-performance-report`,
    filename: "daily-mmo-performance-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },
  {
    name: "Day wise MMO Visit Report",
    url: `/api/reports/v3/mmo-visit-report`,
    filename: "mmo-visit-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },
  {
    name: "Active MMO Count Report",
    url: `/api/reports/v3/active-mmo-count-report`,
    filename: "active-mmo-count-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },

  {
    name: "MDO Average Performance",
    url: `/api/reports/v3/agency-wise-report`,
    filename: "agency-wise_mdo_average_performance_report",
    file_type: "xlsx",
  },
  // {
  //   name: "Competition Update Report",
  //   url: `/api/reports/v1/competition-update-report`,
  //   filename: "competition_update_report",
  //   file_type: "xlsx",
  // },
  {
    name: "Cumulative Merchant Unique Visit Report",
    url: `/api/reports/v1/cumulative-merchant-unique-visit-summary-report`,
    filename: "cumulative_merchant_unique_visit_summary_report",
    file_type: "xlsx",
  },
  {
    name: "Not Visited Merchant List Report",
    url: `/api/reports/v1/not-visited-merchant-list-report`,
    filename: "not_visited_merchant_list_report",
    file_type: "xlsx",
  },
  {
    name: "Unique Regular Visit Report",
    url: `/api/reports/v1/unique-visit-summary-report`,
    filename: "unique_regular_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Spot Info Report",
    url: `/api/reports/v3/spot-info-report`,
    filename: "spot_info_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Spot Mapping Report",
    url: `/api/reports/v3/spot-mapping-report`,
    filename: "spot_mapping_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Report",
    url: `/api/reports/v3/merchant-list-report`,
    filename: "merchant_report_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Lead Report",
    url: `/api/reports/v3/merchant-lead-report`,
    filename: "merchant_lead_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Last Followup Report",
    url: `/api/reports/v3/merchant-last-visit-report`,
    filename: "merchant_last_followup_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Next Followup Report",
    url: `/api/reports/v3/merchant-followup-report`,
    filename: "merchant_next_followup_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Lead Close Report",
    url: `/api/reports/v3/merchant-lead-close-report`,
    filename: "merchant_lead_close_report",
    file_type: "xlsx",
  },
  {
    name: "Employee information Report",
    url: `/api/reports/v3/mdo-information-report`,
    filename: "employee_mdo_information_report",
    file_type: "xlsx",
  },
  {
    name: "Route Performance Report",
    url: `/api/reports/v3/route-performance-report`,
    filename: "route_performance_report",
    file_type: "xlsx",
  },
];

const kam_reports = [
  {
    name: "Raw Data Report",
    url: `reports/v1/raw-data-report`,
    filename: "raw_data_report",
    file_type: "xlsx",
  },
  {
    name: "Not Visited Merchant Report",
    url: `reports/v1/not-visited-merchant-report`,
    filename: "not_visited_merchant_report",
    file_type: "xlsx",
  },
  {
    name: "Unique Merchant Visit Report",
    url: `reports/v1/unique-merchant-visit-report`,
    filename: "unique_merchant_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Cumulative Merchant Visit Report",
    url: `reports/v1/cumulative-merchant-visit-report`,
    filename: "cumulative_merchant_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Servicing Status Report",
    url: `reports/v1/servicing-status-report`,
    filename: "servicing_status_report",
    file_type: "xlsx",
  },
];

const kam_merchant_management_reports = [
  {
    name: "Merchant Management Portal Report",
    url: `reports/v1/mmt/raw-service-report`,
    filename: "mmt_portal_report",
    file_type: "xlsx",
  },
];

class Reports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      currentPage: null,
      filterElement: null,
      isReportViewCompact: false,
      filter: "general",
    };
  }

  getReportTabItems() {
    const items = [
      { title: "General", key: "general" },
      { title: "Merchant", key: "merchant" },
    ];

    if (this.props.userType === "bkash-super-user") {
      items.push({ title: "Acquisition", key: "acquisition" });
    }

    if (this.props.userType === "bkash-super-user") {
      items.push({ title: "Categorization", key: "categorization" });
    }

    return items;
  }

  handleReportView = () => {
    this.setState((prevState) => ({
      isReportViewCompact: !prevState.isReportViewCompact,
    }));
  };

  componentDidMount() {
    this.set_data_set();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filterElement !== prevProps.filterElement)
      this.set_data_set();
  }

  set_data_set = () =>
    this.setState({
      currentPage: this.props.currentPage,
      filterElement: this.props.filterElement,
    });

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  async remove_all_filter() {
    await this.props.updateFilterElement({
      reports: {
        relational: {},
        non_relational: {},
      },
    });
  }

  filteUserTypePermission = (i) => {
    const user_type = JSON.parse(localStorage.getItem("currUserType"));
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();
    const scope = localStorage.getItem("scope");
    return (
      <div className="main-container">
        <div
          className={
            JSON.parse(localStorage.getItem("currUserType")) !==
              "agency_user" && this.props.portal !== "kam"
              ? "reports"
              : "full-width-reports"
          }
          style={{
            paddingLeft: 24,
            paddingRight: this.state.filter === "general" ? 284 : 24,
          }}
        >
          <div className="page-header">
            <div className="page-heading" style={{ display: "flex" }}>
              Reports
              <div style={{ marginLeft: 100 }}>
                {scope !== "online" && (
                  <ToggleButtonGroupBkash
                    config={this.getReportTabItems()}
                    alignment={this.state.filter}
                    setAlignment={(f) => this.setState({ filter: f })}
                  />
                )}
              </div>
            </div>
            <div className="page-settings">
              <div className="info-report-view">
                {this.state.filter === "general" && (
                  <Calendar
                    page={"reports"}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                  />
                )}
              </div>
            </div>
          </div>

          {this.state.filter === "merchant" ? (
            <MerchantReports />
          ) : this.state.filter === "acquisition" ? (
            <AcquisitionReports />
          ) : this.state.filter === "categorization" ? (
            <CategorizationReports />
          ) : (
            <GeneralReports />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  let startDate = state.calendar.reports
    ? state.calendar.reports.startDate
    : state.calendar.default.startDate;
  let endDate = state.calendar.reports
    ? state.calendar.reports.endDate
    : state.calendar.default.endDate;
  let currentPage = state.page.currentPage;
  let filterElement = state.filterElement.reports
    ? state.filterElement.reports
    : state.filterElement.default;
  let filterHide = state.filter.filterHide;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let portal = state.auth.authToken ? state.auth.authToken.portal : "dexter";

  let userType = state.auth.authToken ? state.auth.authToken.type : null;

  return {
    startDate,
    endDate,
    currentPage,
    filterElement,
    filterHide,
    expiration,
    portal,
    userType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilterElement: (filter) => dispatch(updateFilterElement(filter)),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
